import React, { useEffect, useState } from 'react';
import db from './firebase';
import { useParams } from 'react-router-dom';

function Redirect() {
  const { slug } = useParams();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [message, setMessage] = useState('Connecting...');

  useEffect(() => {
    let query = db.collection('urls').where('slug', '==', slug);
    query.onSnapshot((data) => {
      if (data.empty) {
        setMessage('URL not found');
      } else {
        setMessage('Thanks for your interest in me.');
        setShouldRedirect(true);
      }
    });
  }, [slug]);

  useEffect(() => {
    const handleRedirect = () => {
      if (shouldRedirect) {
        let query = db.collection('urls').where('slug', '==', slug);
        query.onSnapshot((data) => {
          let finalData = data.docs[0].data();
          let url = finalData.url;
                window.location.href = `vnd.youtube://youtube.com/redirect?event=comments&redir_token=QUFFLUhqbTdEbWxvOXY4UjFUVUh6dzFndFFxUERycGdjZ3xBQ3Jtc0trMW5TQW8yU3Y0M25Nemp0RHMwNWV3ZHJ5Q1BfQnQxREg5cmdJMTI2SHFybU5BUV82cE1Cb1JVdGs5Q0d2ZE12T0duQmtRLUstNHhfSTZCNHN4RXhTUUpiOG1SN2RXcnpwTFUtQ0FaRHdMa1JWVVZ1WQ&q=${url}&html_redirect=1`
        });
      }
    };

    handleRedirect();
  }, [shouldRedirect, slug]);

  return (
    <div>
      <center>
        <p>{message}</p>
      </center>
    </div>
  );
}

export default Redirect;
